<template>
  <div class="p-people">

    <div class="s-header">
      <div class="s-header-copy">
        <div class="s-header-title">
          <ul class="f-xs">
            <li>People</li>
            <li>
              <a class="l-rg p-cta" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
            </li>
          </ul>
        </div>
        <div class="s-header-head">
          <h1 class="f-xl">
            <span class="f-xl-line">Longevity.</span>
            <span class="f-xl-line">Integrity.</span>
            <span class="f-xl-line">Passion.</span>
          </h1>
        </div>
      </div>

      <div style="display: none;">
        <div class="s-header-scroll">
          <i class="s-header-indicator"></i>
          <p class="f-xs">Scroll &amp; Discover</p>
        </div>
      </div>

      <div class="s-header-image">
        <div class="s-header-src"></div>
      </div>

      <div class="scroll-down">
        <div class="scroll-down-arrow" @click="emitEventScroll"></div>
      </div>
    </div>

    <div class="s-marquee">
      <div class="s-marquee-head">
        <h3 class="f-xs"></h3>
      </div>
      <div class="s-marquee-wrap">
        <h2 class="f-xl">Extensive Multi-Cycle Experience</h2>
      </div>
    </div>

    <div class="s-text">
      <div class="s-text-head">
        <h3 class="f-xs"></h3>
      </div>
      <div class="s-text-wrap">
        <p class="f-md" data-animate="fade">
          We take pride in the quality, longevity and continuity of our team.
          Our investment professionals have an average of 17 years of experience in financial markets,
          and the average tenure at VR of our senior investment professionals is over 19 years.
          Our senior business professionals have been at VR for an average of over 16 years.
        </p>
      </div>
    </div>

    <Team />

    <div class="s-bio-container">
      <div class="s-bio-container-wrapper" :class="{ open: $route.name === 'bio' }">
        <router-view></router-view>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import gsap from 'gsap';
import Sniffer from 'sniffer';
import Team from '@/components/team/team.vue';
import Footer from '@/components/footer/footer.vue';


export default {
  components: {
    Team,
    Footer,
  },

  mounted() {
    gsap.ticker.add(this.run);
  },
  beforeDestroy() {
    gsap.ticker.remove();
  },

  methods: {
    run() {
      const { top } = this.$el.getBoundingClientRect();
      this.$el.querySelector('.s-bio-container').style.transform = `translateY(${top * -1}px)`;
    },

    emitEventScroll() {
      const scrollToEvent = new CustomEvent('customScrollTo', {
        detail: { scrollVal: window.innerHeight },
      });
      if (Sniffer.isPhone) gsap.to('.a-scroll', { duration: 1, scrollTo: window.innerHeight });

      window.dispatchEvent(scrollToEvent);
    },
  },
};
</script>
